import PropTypes from 'prop-types';
import React from 'react';
import MenuItemAction from './MenuItemAction';
import keys from '../lib/keyConstants';

class ButtonMenuItemAction extends React.Component {
    onKeyDown(e) {
        if (e.key === keys.SPACE || e.key === keys.ENTER) {
            this.props.onSelect(e);
            e.preventDefault();
            e.stopPropagation();
        }
    }

    render() {
        return (
            <button
                onKeyDown={this.onKeyDown}
                className="menu__item__action__link"
                onClick={this.props.onSelect}
            >
                {this.props.children}
            </button>
        );
    }
}

ButtonMenuItemAction.propTypes = {
    onSelect: PropTypes.func.isRequired,
};

export default MenuItemAction(ButtonMenuItemAction);



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/ButtonMenuItemAction.jsx